export default {
  options: {
    true: 'Oui',
    false: 'Non',
  },
};
